<template>
  <div v-if="isShow">
    <transition name="alert" @after-leave="afterTransitionLeave">
      <div v-if="visible" class="alert">
        <i class="alert-dim" />
        <div class="alert-inner">
          <p class="msg"> <html-view v-if="message" v-model="message" /></p>
          <div class="btn-wrap">
            <button type="button" @click="onConfirm">{{ confirmMessage }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  data () {
    return {
      visible: false,
      eventStatus: null
    }
  },
  computed: {
    confirmMessage () {
      return window.getApp.$t('alert.confirm')
    }
  },
  beforeMount () {
    this.$on('alert:open', () => {
      this.visible = true
    })
    this.$on('alert:close', () => {
      this.visible = false
    })
  },
  methods: {
    afterTransitionLeave () {
      this.$alert.close()
      this.$emit(this.eventStatus)
    },
    onConfirm () {
      this.$emit('alert:close')
      this.eventStatus = 'alert:cancel'
    }
  }
}
</script>
